<template>
  <div class="SelectRegionPane">
    <div class="title">{{ title }}</div>
    <nav class="options">
      <a v-for="{ locale, countryName, rootUrl } in localeOptions"
        :key="locale"
        class="option"
        :href="rootUrl"
      >
        <FlagIcon :locale="locale" />
        <span class="countryName">{{ countryName }}</span>
      </a>
    </nav>
  </div>
</template>

<script>
import FlagIcon from '../FlagIcon.vue'
import localeInfo from '~/data/localeInfo.json'

export default {
  components: {
    FlagIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    localeOptions() {
      return Object.entries(localeInfo)
      .map(([locale, localeInfoFields]) => ({ locale, ...localeInfoFields }))
      .sort((entryA, entryB) => entryA.countryName.localeCompare(entryB.countryName))
    },
  },
}
</script>

<style scoped>

.SelectRegionPane {
  max-height: 100%;
  padding-top: var(--spacing-12);
  padding-right: var(--spacing-11);
  padding-bottom: var(--spacing-10);
  padding-left: var(--spacing-11);
  overflow: auto;
}

.title {
  font-weight: 500;
  font-size: var(--font-size-7);
}

.options {
  margin-top: var(--spacing-6);
}

.option {
  display: flex;
  align-items: center;
  padding: var(--spacing-6) 0;
  border-bottom: 2px solid #eee;
  transition: color 0.15s;
}
.option:hover {
  color: var(--text-link-hover-color);
}
.option:last-of-type {
  border-bottom: none;
}

.countryName {
  font-weight: 500;
  font-size: var(--font-size-4);
  margin-left: var(--spacing-8);
}
</style>
